// extracted by mini-css-extract-plugin
export var banner = "_hz-0";
export var closeButton = "_hz-2";
export var greenCheckmark = "_hz-3";
export var hereLink = "_hz-4";
export var titleIcon = "_hz-1";